import React from 'react';

const PurchaseInvoicePage = React.lazy(() => import('pages/PurchaseInvoice/pages/ListPage'));

const invoiceManagementRoute = [
  {
    path: '/invoice-management',
    exact: true,
    name: 'Danh sách hóa đơn mua hàng',
    function: 'SL_INVOICE_VIEW',
    component: PurchaseInvoicePage,
  },
  {
    path: '/purchase-invoice',
    exact: true,
    name: 'Hóa đơn mua hàng',
    function: 'SL_INVOICE_VIEW',
    component: PurchaseInvoicePage,
  },
];

export default invoiceManagementRoute;
